import { Typography } from 'antd';
import { SoundOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface PushPreviewProps {
  title: string;
  body: string;
}

/**
 * Small iPhone-style live preview of how the push notification will look on a lock screen.
 * Purely presentational — no data fetching.
 */
export function PushPreview({ title, body }: PushPreviewProps) {
  return (
    <div
      style={{
        maxWidth: 320,
        borderRadius: 14,
        background: 'rgba(245, 245, 247, 0.95)',
        boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
        padding: '10px 12px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: 4,
            background: '#1890ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SoundOutlined style={{ fontSize: 10, color: '#fff' }} />
        </div>
        <Text style={{ fontSize: 11, color: '#8c8c8c', letterSpacing: 0.5 }}>MYGATE</Text>
        <Text style={{ fontSize: 11, color: '#8c8c8c', marginLeft: 'auto' }}>now</Text>
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a1a', lineHeight: 1.3 }}>
        {title || <Text type="secondary">Notification title</Text>}
      </div>
      <div style={{ fontSize: 13, color: '#333', lineHeight: 1.4, wordBreak: 'break-word' }}>
        {body || <Text type="secondary">Notification body preview appears here</Text>}
      </div>
    </div>
  );
}
